module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/footer/mobile_tribune-00c8384451c995a0950dc20a6b42e0a6.jpg";